module.exports = __webpack_public_path__ + "static/media/woodcraft.2b721873.jpg";